import React from "react";
import { forwardRef } from "react";
import "../styles/Footer.css";

const Footer = forwardRef((props, ref) => {
  return (
    <footer ref={ref} className="footer">
      <div className="footer-content">

        <div className="footer-contact">
          <h1>
            Let’s <span className="highlight">discuss<br></br></span> your <span className="highlight">vision</span> with us
          </h1>
          <></>
          <span className="social-btn">
            <a className="social-link insta" href="https://www.instagram.com/innovastraa_/"><i class="fi fi-brands-instagram"></i></a>

            {/* <a className="social-link insta" href=""><i class="fi fi-brands-instagram"></i></a>  */}

            {/* {/* <a className="social-link" href=""><i class="fi fi-brands-instagram"></i></a> */}

          </span>
        </div>

        <div className="footer-address">
          <h2>CONTACT US</h2>
          <p>Arya College of Engineering</p>
          <p>SP-40, RIICO Industrial Area, Delhi Road, <br></br><br></br>Kukas, Jaipur, Raj.(302028)</p>
          <p><a href="tel:+91 9664464843">+91 9664464843</a></p>
          <p><a href="tel:+91 7726066155">+91 7726066155</a></p>
          <p><a href="mailto:innovastraa@gmail.com">innovastraa@gmail.com</a></p>
        </div>

        <div className="footer-map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4608.917737753025!2d75.88784460048251!3d27.03138286356784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396daff75daffa4d%3A0x3b7007c44ebf96df!2sArya%20Main%20Campus!5e0!3m2!1sen!2sin!4v1739206426443!5m2!1sen!2sin" className="map-sec" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
